import React from 'react';
import { Button, Header, Dimmer } from 'semantic-ui-react';

import DEFAULT_TABS from '../tabs/defaultTabs';
import * as config from '../config';
import LoginError from '../components/LoginError';
import LoginComponent from '../components/LoginComponent';
import Logo from '../components/Logo';
import Timeout from '../components/Timeout';

const AUTH_TIMEOUT_MS = 5000;

/**
 * Context with all info related to user and integration
 *
 * The value of this context is initially null, but is updated after authentication.
 */
const AuthContext = React.createContext(null);

export default AuthContext;


export class AuthProvider extends React.Component {
  state = {
    availableTabs: DEFAULT_TABS,
    retryCount: 0,
    auth: null,
  };

  // Called when the user indicates to retry a failed authentication attempt
  handleRetry = () => {
    // Increment the retryCount, which restarts the timer and begins the login flow again
    this.setState((state) => ({...state, retryCount: state.retryCount + 1}));
  };

  // Called when the user has succesfully authenticated
  handleLogin = (auth) => {
    this.setState((state) => ({...state, auth}));
  };

  render() {
    const { children, placeholder } = this.props;
    const { auth, availableTabs, retryCount } = this.state;
    const { handleLogin, handleRetry } = this;

    return (
      <AuthContext.Provider value={{availableTabs, ...auth}}>
        {auth ? children : placeholder}
        {auth ? null : (
          <Dimmer active verticalAlign="top">
            <Timeout
              key={retryCount}
              delay={AUTH_TIMEOUT_MS}
              before={(
                <React.Fragment>
                  <Logo spinning />
                  <Header as="h3" color="grey">Authenticating</Header>
                  <LoginComponent onLogin={handleLogin} />
                </React.Fragment>
              )}
              after={(
                <React.Fragment>
                  <Logo />
                  <LoginError />
                  <Button primary onClick={handleRetry}>Retry</Button>
                </React.Fragment>
              )}
            />
          </Dimmer>
        )}
      </AuthContext.Provider>
    );
  }
}
